<template>
	<div class="product" v-if="product.name">
		<div class="product-image">
			<img :src="product.thumbnail" :alt="product.name">
		</div>
		<div class="product-info">
			<span class="product-title" v-text="product.name"></span>
			<div class="product-descriptions">
				<span v-text="`${product.type.name} ${product.strength}`"></span>
				<div class="product-descriptions--meta">
					<span v-text="product.quantity"></span>
					<span v-show="product.prescriptionOnly">, Rx only</span>
				</div>
			</div>
			<div class="product-meta">
				<div v-text="product.info"></div>
			</div>
			<span class="product-price" v-text="`\$ ${product.price}.00`"></span>
			<a :href="`/cart/products/${id}`" class="button button-primary" v-text="`${action} ${product.name} ${product.strength}`"></a>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		props: {
			id: {},
			action: {default: 'Get'}
		},
		data: function () {
			return {
				product: {
					type: {}
				}				
			}
		},
		mounted() {
			axios.get(`/api/v1/products/${this.id}`)
				.then((response) => {
					this.product = response.data.data;
				});
		}	
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/Product.vue